import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { EnvelopeSimple } from "@phosphor-icons/react";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    try {
      await api.post("/newsletter/subscribe", { email });
      setSent(true);
      toast.success("Subscribed. Check your inbox.");
    } catch { toast.error("Could not subscribe"); }
  };

  return (
    <main className="max-w-4xl mx-auto px-6 py-24" data-testid="newsletter-page">
      <p className="overline opacity-60 mb-2">// Newsletter</p>
      <h1 className="font-display font-black text-5xl md:text-6xl tracking-tighter leading-none mb-8">
        Early access.<br/><span className="font-light italic">Zero spam.</span>
      </h1>
      <p className="font-sans text-lg text-neutral-400 max-w-2xl leading-relaxed mb-10">
        Join the list for new drops, handmade releases, digital goods, and crypto-friendly offers.
        One letter, delivered when it matters.
      </p>
      {sent ? (
        <div className="border border-signal bg-[#111111] p-8 flex items-start gap-4">
          <EnvelopeSimple size={32} weight="duotone" className="text-signal shrink-0 mt-1"/>
          <div>
            <p className="font-display font-black text-xl">You're on the list.</p>
            <p className="font-sans text-neutral-400 mt-2">Keep an eye on your inbox for a welcome note.</p>
          </div>
        </div>
      ) : (
        <form onSubmit={subscribe} className="flex flex-col sm:flex-row gap-3 max-w-xl" data-testid="newsletter-form">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                 placeholder="you@email.com"
                 className="input-sharp flex-1" data-testid="newsletter-email" />
          <button type="submit" className="btn-signal" data-testid="newsletter-submit">Subscribe →</button>
        </form>
      )}
    </main>
  );
}
